import { render, staticRenderFns } from "./loginAuth.vue?vue&type=template&id=39c0a527&scoped=true&"
import script from "./loginAuth.vue?vue&type=script&lang=js&"
export * from "./loginAuth.vue?vue&type=script&lang=js&"
import style0 from "./loginAuth.vue?vue&type=style&index=0&id=39c0a527&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c0a527",
  null
  
)

export default component.exports